import computedStyle from 'computed-style'
import Tween from 'component-tween'
import raf from 'component-raf'
import props from 'prop-detect'
import within from 'within-document'

let pxStyles = [
  'width',
  'height',
  'left',
  'right',
  'top',
  'bottom'
]

function toStyle(o) {
  let res = {}
  Object.keys(o).forEach(key => {
    if (key == 'x') {
      res[props.transform] = `translateX(${o[key]}px)`
    } else if (key == 'y') {
      res[props.transform] = `translateY(${o[key]}px)`
    } else if (key == 'scale') {
      res[props.transform] = `scale(${o[key]})`
    } else if (pxStyles.indexOf(key) !== -1) {
      res[key] = `${o[key]}px`
    } else {
      res[key] = o[key]
    }
  })
  return res
}

export default (el, {from = {}, to = {}, ease = 'linear', duration = 200}) => {
  if (!within(el)) return Promise.resolve(null)
  Object.keys(to).forEach(key => {
    if (key == 'x' && from[key] == null) throw new Error('from x required')
    if (key == 'y' && from[key] == null) throw new Error('from y required')
    if (from[key] == null) {
      let val = parseInt(computedStyle(el, key), 10)
      from[key] = val
    }
  })
  let tween = Tween(from)
    .ease(ease)
    .to(to)
    .duration(duration || 200)

  tween.update(o => {
    Object.assign(el.style, toStyle(o))
  })

  let promise = new Promise(resolve => {
    tween.on('end', () => {
      animate = () => {} // eslint-disable-line
      resolve(tween.stopped)
    })
  })

  function animate() {
    raf(animate)
    tween.update()
  }
  promise.stop = tween.stop.bind(tween)
  animate()
  return promise
}
